import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

import { useStyles } from './styles';

/**
 * Custom Linear Progress Bar
 * @param {Object} props
 * @param {string} [props.backgroundColor] - Background color of the progress bar container
 * @param {string} [props.borderColor] - Border color of the progress bar
 * @param {string} [props.color] - Color of the progress bar fill
 * @param {number} [props.max=100] - Maximum value the progress bar can have
 * @param {number} [props.size=12] - Height and border radius in pixels
 * @param {number} [props.value=0] - Current progress value
 * @param {string} [props.variant='determinate'] - Material-UI LinearProgress variant: 'buffer', 'determinate', 'indeterminate', or 'query'
 */
const FPLinearProgress = ({
  backgroundColor,
  borderColor,
  color,
  max = 100,
  size = 12,
  value = 0,
  variant = 'determinate'
}) => {
  const classes = useStyles({ backgroundColor, borderColor, color, size });

  const { container: containerClass, ...overridedClasses } = classes;

  const progress = (value * 100) / max;

  return (
    <div className={containerClass}>
      <LinearProgress
        role="progressbar"
        classes={overridedClasses}
        variant={variant}
        value={progress}
      />
    </div>
  );
};

export default FPLinearProgress;
